<template>
  <div :class="spacerStyle" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  mt: {
    type: Number,
    required: true
  }
})

const { mt1, mt2, mt3, mt4, mt5, mt6, mt7 } = useCssModule()

const spacerStyle = computed(() => {
  let style = ''

  switch (props.mt) {
    case 1:
      style = mt1
      break
    case 2:
      style = mt2
      break
    case 3:
      style = mt3
      break
    case 4:
      style = mt4
      break
    case 5:
      style = mt5
      break
    case 6:
      style = mt6
      break
    case 7:
      style = mt7
      break
    default:
      throw new Error('Not implemented')
  }

  return style
})
</script>

<style module>
.mt1 {
  margin-top: var(--space-xxs);
}

.mt2 {
  margin-top: var(--space-xs);
}

.mt3 {
  margin-top: var(--space-sm);
}

.mt4 {
  margin-top: var(--space-md);
}

.mt5 {
  margin-top: var(--space-lg);
}

.mt6 {
  margin-top: var(--space-xl);
}

.mt7 {
  margin-top: var(--space-xxl);
}
</style>
